export default __webpack_public_path__ + "static/media/3.a6fc5b9e.jpg";